import { render, staticRenderFns } from "./CodePackage.vue?vue&type=template&id=0771ef76&scoped=true&"
import script from "./CodePackage.vue?vue&type=script&lang=js&"
export * from "./CodePackage.vue?vue&type=script&lang=js&"
import style0 from "./CodePackage.vue?vue&type=style&index=0&id=0771ef76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771ef76",
  null
  
)

export default component.exports